import ReactApexChart from 'react-apexcharts';
import { withNamespaces } from 'react-i18next';
import { Card, CardBody, CardTitle } from 'reactstrap';

import { TasksStatuses } from 'src/modules/3rd-party-management/constants';

import useSupplierOverviewTaskRiskOverview from '../../hooks/useSupplierOverviewTaskRiskOverview';

const TasksChartSkeleton = () => (
    <>
        <div className="dt-field dt-skeleton mb-2" style={{ width: '30%' }} />
        <div className="dt-field dt-skeleton" style={{ width: '90%', height: '320px' }} />
    </>
);

const TasksChart = ({
    t,
    supplierId,
}) => {
    const fetchTaskRiskOverviewQuery = useSupplierOverviewTaskRiskOverview({
        supplierId,
        t,
    });

    if (fetchTaskRiskOverviewQuery.isLoading || fetchTaskRiskOverviewQuery.isFetching) {
        return <TasksChartSkeleton />;
    }

    const items = fetchTaskRiskOverviewQuery.data?.tasks?.items || [];

    const chartOptions = {
        labels: [],
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                },
            },
        },
        dataLabels: {
            enabled: true,
            dropShadow: false,
            formatter: (val, x) => {
                return x.w.config.series[x.seriesIndex];
            },
        },
        legend: {
            show: true,
            position: 'bottom',
        },
        colors: [],
    };

    const series = [];
    const labels = [];
    const colors = [];

    items.forEach((item) => {
        if (TasksStatuses[item.status]) {
            series.push(parseInt(item.amount));
            labels.push(t(TasksStatuses[item.status].title));
            colors.push(TasksStatuses[item.status].color);
        }
    });

    const isSeriesEmpty = !series.length || series.every((s) => s === 0);

    return (
        <Card>
            <CardBody>
                <CardTitle className="overview-section-title mb-4">
                    {t('Tasks')}
                </CardTitle>

                <ReactApexChart
                    options={{
                        ...chartOptions,
                        labels: isSeriesEmpty ? [t('No Data')] : labels,
                        colors: isSeriesEmpty ? ['e0e0e0'] : colors,
                    }}
                    series={isSeriesEmpty ? [1] : series}
                    type="donut"
                    height="350px"
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(TasksChart);
